<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { mapState } from "../../context/context";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { styles: true },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.primaryPattern"]);

const color = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.primaryPattern"].value;
});
</script>

<template>
  <div class="icon-loading">
    <svg
      viewBox="25 25 50 50"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="none"
      fill="none"
      :style="{
        display: 'block',
        transformOrigin: 'center'
      }"
    >
      <circle
        cx="50"
        cy="50"
        r="20"
        :style="['stroke: ' + color]"
      />
    </svg>
  </div>
</template>

<style scoped>
.icon-loading {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.icon-loading svg {
  transform-origin: center;
  animation: rotate 2s linear infinite;
  width: 50%;
  aspect-ratio: 1 / 1;
}
.icon-loading circle {
  fill: none;
  stroke-width: 3;
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dashoffset: -125px;
  }
}
</style>
